import type { Catalog } from "../../en";

/** Filipino: platform admin tenants screen (mirrors en). */
export const tenants: Catalog["adminScreens"]["tenants"] = {
  title: "Mga tenant",
  subtitle: "Bawat organisasyon sa Sagot — mga paaralan, klinika, realty, resort at LGU pilot.",
  exportAll: "I-export lahat",
  exported: "Na-export ang {{file}} · {{count}} hanay",
  exportFailed: "Hindi natapos ang export. Subukan ulit.",
  createTenant: "Gumawa ng tenant",
  stats: {
    label: "Buod ng mga tenant",
    total: "Kabuuan",
    paying: "Aktibo (nagbabayad)",
    mrr: "{{amount}} MRR",
    trial: "Naka-trial / pilot",
    pastDue: "Lampas sa takdang bayad",
    outstanding: "{{amount}} na hindi pa nababayaran",
    suspended: "Suspendido",
    active: "{{count}} aktibo",
  },
  filters: {
    label: "I-filter ang mga tenant",
    search: "Hanapin ang pangalan, domain o may-ari…",
    plan: "Plano",
    allPlans: "Lahat ng plano",
    status: "Status",
    allStatuses: "Lahat ng status",
    industry: "Industriya",
    allIndustries: "Lahat ng industriya",
    region: "Rehiyon",
    allRegions: "Lahat ng rehiyon",
    reset: "I-reset",
  },
  industries: {
    education: "Edukasyon",
    school: "Edukasyon",
    healthcare: "Klinika",
    clinic: "Klinika",
    real_estate: "Real estate",
    hospitality: "Hospitality",
    government: "Pamahalaan",
    human_resources: "HR",
    ecommerce: "E-commerce",
    other: "Iba pa",
  },
  bulk: {
    selected_one: "{{count}} ang napili",
    selected_other: "{{count}} ang napili",
    exportCsv: "I-export ang CSV",
    emailOwners: "I-email ang mga may-ari",
    addTag: "Magdagdag ng tag",
    clear: "I-clear ang pinili",
    unavailable: "Hindi pa available",
  },
  table: {
    label: "Direktoryo ng mga tenant",
    selectAll: "Piliin ang lahat ng tenant sa pahinang ito",
    select: "Piliin ang {{tenant}}",
    tenant: "Tenant",
    industry: "Industriya",
    plan: "Plano",
    status: "Status",
    agents: "Mga agent",
    messages: "Mga mensahe ngayong buwan",
    mrr: "MRR",
    created: "Ginawa",
    owner: "May-ari",
    actions: "Mga aksyon",
    rowActions: "Mga aksyon para sa {{tenant}}",
    usageLabel: "Mga mensahe ngayong buwan ng {{tenant}}",
    custom: "custom",
    showing_one: "Ipinapakita ang {{count}} tenant",
    showing_other: "Ipinapakita ang {{count}} tenant",
    showingOf_one: "Ipinapakita ang {{shown}} sa {{count}} tenant",
    showingOf_other: "Ipinapakita ang {{shown}} sa {{count}} tenant",
    page: "Pahina {{page}}",
    prev: "Nakaraan",
    next: "Susunod",
    pagination: "Mga pahina ng tenant",
  },
  menu: {
    view: "Tingnan ang tenant",
    copyId: "Kopyahin ang tenant ID",
    idCopied: "Nakopya ang tenant ID",
    copyFailed: "Hindi makopya sa clipboard",
    suspend: "I-suspend",
    reinstate: "Ibalik",
    delete: "Burahin",
  },
  empty: {
    title: "Walang tenant na tugma sa mga filter na ito",
    body: "Subukan ang ibang plano, status o rehiyon.",
    reset: "I-reset ang mga filter",
    noneTitle: "Wala pang tenant",
    noneBody: "Gumawa ng unang workspace at imbitahan ang may-ari nito.",
  },
  create: {
    title: "Gumawa ng tenant",
    description: "Maghanda ng workspace at imbitahan ang may-ari nito.",
    name: "Pangalan ng organisasyon",
    namePlaceholder: "hal. Holy Angel Learning Center",
    nameInvalid: "Maglagay ng 2–120 karakter.",
    ownerEmail: "Email ng may-ari",
    ownerEmailPlaceholder: "owner@organization.ph",
    ownerEmailInvalid: "Maglagay ng wastong email address.",
    industry: "Industriya",
    plan: "Plano",
    planPrice: "{{plan}} — {{price}}/buwan",
    planCustom: "{{plan}} — custom",
    trialDays: "Mga araw ng trial",
    trialDaysHint: "Karaniwang 30–60 araw ang LGU pilot.",
    trialDaysInvalid: "Maglagay ng 0–90 araw.",
    dataRegion: "Rehiyon ng data",
    regionSingapore: "ap-southeast-1 (Singapore)",
    regionOnPrem: "Pilipinas (on-prem / DaaS)",
    dataRegionHint: "Data Privacy Act 2012: itala ang cross-border transfer sa DPA.",
    subdomain: "Address ng web app",
    subdomainPlaceholder: "holyangel",
    subdomainInvalid: "Gumamit ng 3–63 maliliit na titik, numero o gitling.",
    subdomainHint: "Iwanang blangko para kunin ito sa pangalan.",
    sendInvite: "Ipadala ngayon ang imbitasyon",
    sendInviteHint: "Makakatanggap ang may-ari ng magic link na valid nang 72 oras.",
    submit: "Gumawa ng tenant",
    done: "Nagawa ang tenant · naipadala ang imbitasyon sa may-ari",
    doneNoInvite: "Nagawa ang tenant",
  },
};
